import { render, staticRenderFns } from "./edit-dates-closed-popup.vue?vue&type=template&id=a3e5b336"
import script from "./edit-dates-closed-popup.vue?vue&type=script&lang=js"
export * from "./edit-dates-closed-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports